import { PlatformPressable } from '@react-navigation/elements';
import { scale } from '@utils/normalize';
import React from 'react';
import colors from './colors';

export function getSvgProps(focused: Boolean) {
  return focused
    ? { fill: colors.primary.carnation, width: scale(24), height: scale(24) }
    : { width: scale(24), height: scale(24) };
}

export function getTabBarComponent(labelName?: string) {
  return (props: any) => (
    <PlatformPressable testID={`tab_${labelName}`} {...props} android_ripple={{ color: 'transparent' }} />
  );
}
